import React, { useContext, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { priceCurveMultiLineChartParser, priceCurveMultiLineTableParser } from 'parser/priceCurveParser';
import { getPriceCurveChart1 } from 'gqlQueries/priceCurve';
const errorMessage: string = 'Something went wrong!';

function useFetchMultiLineChartData({ yAxisSelectedValue }: any) {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const [count, setCount] = useState(0);
    const variablesRef = useRef<any>({});
    const { appConfig } = useContext(UserContext);

    const [
        fetchMultiLineChartData,
        { data: multiLineChartData, loading: multiLineChartDataLoading, error: multiLineChartDataError },
    ] = useLazyQuery(getPriceCurveChart1, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getPriceCurveData: getPriceCurveChart1Data } = payload;
            if (getPriceCurveChart1Data && 'data' in getPriceCurveChart1Data) {
                if (getPriceCurveChart1Data?.data?.length === 0) throw 'No Data';
                const parsedChartData = priceCurveMultiLineChartParser(
                    getPriceCurveChart1Data?.data,
                    appConfig,
                    yAxisSelectedValue,
                    variablesRef.current?.metricType,
                );
                const min = Math.min(data?.min || 0, parsedChartData.min);
                const max = Math.max(data?.max || 0, parsedChartData.max);
                const legends = getPriceCurveChart1Data?.levelsLegendLst?.map((item: any) => {
                    return {
                        label: item,
                        key: item,
                    };
                });
                setData({
                    min,
                    max,
                    chartData: parsedChartData?.result,
                    tableData: parsedChartData?.tableData,
                    legends,
                    xAxisValues: parsedChartData.xAxisValues,
                });
            }
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData(null);
        setCount(0);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        count,
        data,
        fetchMultiLineChartData: (variables: any) => {
            variablesRef.current = variables.variables;
            //only set data to null if function is being called outside/without infinite scroll
            //if offset is equal to default offset, it means request is coming without infinite scroll
            // if (commonConfig.offset === variables.variables?.offset) {
            //     setData(null);
            //     rawDataRef.current = [];
            //     setError(null);
            // }
            setData(null);
            setLoading(true);
            setError(null);
            fetchMultiLineChartData(variables);
            //onFetchComplete(variables);
        },
    };
}

export { useFetchMultiLineChartData };
